import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import { SHIFT_TYPE } from 'models/Shift'
import { TDay } from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { TSingleDayShift } from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { FormikProps } from 'formik'
import { updateSpecificDay } from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils'

export const handleDeletePress = (
  day: TSingleDayShift | TDay,
  formik: FormikProps<IScheduleSectionFormValues>
) => {
  const {
    values: { type, single_day_shifts, days },
    setFieldValue,
  } = formik

  // Single day shift - remove day from list
  if (type === SHIFT_TYPE.SINGLEDAY) {
    setFieldValue(
      'single_day_shifts',
      single_day_shifts.filter((shift) => shift.id !== day.id)
    )
  }

  // Multiday shift - mark day as not working and set as dirty
  if (type === SHIFT_TYPE.MULTIDAY) {
    setFieldValue(
      'days',
      days.map((dayItem) =>
        dayItem.id === day.id
          ? { ...dayItem, working: false, is_dirty: true, starting_day: false }
          : dayItem
      )
    )
  }
}

export const handleSetAsWorkingDay = (
  day: TSingleDayShift | TDay,
  formik: FormikProps<IScheduleSectionFormValues>
) => {
  const {
    values: { type, days },
    setFieldValue,
  } = formik
  const { id } = day

  if (type === SHIFT_TYPE.MULTIDAY) {
    const updatedDays = updateSpecificDay(days, Number(id), {
      working: true,
      is_dirty: true,
    })

    setFieldValue('days', updatedDays)
  }
}
